import axios from 'axios';
import BadRequestException from '../../exceptions/BadRequestException';
import IHTTPClientAdapter from './IHTTPClientAdapter';

export default class AxiosAdapter extends IHTTPClientAdapter {
  /** @override */
  async get(url, config) {
    const response = await axios.get(url, config);
    return response.data;
  }
  /** @override */
  async post(url, requestBody, headers) {
    try{
      const response = await axios.post(url, requestBody, {
        headers: headers,
      });
      return response.data;
    } catch (e) {
      if (e.response && e.response.data) {
        throw new BadRequestException(400, e.response.data);
      } else { 
        throw new Error(e.message);
      }
    }
  }

  /** @override */
  async delete(url, headers) {
    try{
      const response = await axios.delete(url, {
        headers: headers,
      });
      return response.data;
    } catch (e) {
      if (e.response && e.response.data) {
        throw new BadRequestException(400, e.response.data);
      } else { 
        throw new Error(e.message);
      }
    }
  }
}
